import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { day } from 'libs/day';
import { FlexReportUnregisteredTableData } from 'libs/domain';
import { RegistrationTypes } from 'libs/domain';
import { registration_pb as reg_pb } from 'libs/generated-grpc-web';
import { registration_ng_grpc_pb } from 'libs/generated-grpc-web';
import { FlexTimeReportColumns } from 'libs/shared';

import { ReportDatasourceService } from '@app/src/app/components/manager-report/services/report-datasource.service';
import { AuthInfoService } from '@app/src/app/minimal/services/AuthInfo';

import { SystemAlertSnackBarService } from '@shared/components/system-alert-snackbar';
import { FlexTimeActivityInstanceService } from '@shared/services/flex-time';
import { FlexTimePermissionsService } from '@shared/services/flex-time/flex-time-permissions';

import { FtmReportsService } from './ftm-reports.service';

@Injectable()
export class FtmReportsUnregisteredDatasourceService extends ReportDatasourceService<FlexReportUnregisteredTableData> {
  constructor(
    _router: Router,
    private _reportService: FtmReportsService,
    private _auth: AuthInfoService,
    private _flexActivityInstanceService: FlexTimeActivityInstanceService,
    private _flexPermissionService: FlexTimePermissionsService,
    private _registrationManager: registration_ng_grpc_pb.RegistrationManager,
    private _systemAlertSnackBar: SystemAlertSnackBarService,
  ) {
    super(_router, _reportService, FtmReportsUnregisteredDatasourceService.name);
    super.setDisplayColumns(FlexTimeReportColumns.UNREGISTERED);
  }

  async fetch(offset: number, limit: number) {
    return await this._reportService.getUnregisteredReport(offset, limit, this._currentSort);
  }

  async completeItem(item: FlexReportUnregisteredTableData): Promise<void> {
    const startDate = day();
    const endDate = day().add(1, 'month');
    const teacher = !this._flexPermissionService.isFlexTimeAdmin() ? this._auth.authPerson : null;
    const periodId = this._reportService.filter.periods[0];

    const activityInstance = await this._flexActivityInstanceService.openActivitySelector({
      periodId,
      startDate,
      endDate,
      selectorType: 'assign',
      teacher,
    });

    if (!activityInstance) {
      return;
    }

    const request = new reg_pb.AssignRequest();
    request.setActivityInstanceId(activityInstance.id);
    request.setPersonHashList([item.hash]);
    request.setType(RegistrationTypes.FLEX_TIME);

    try {
      await this._registrationManager.assign(request);
    } catch (err) {
      this._systemAlertSnackBar.open({
        type: 'error',
        message: 'Error assigning activity: ' + err.message,
      });
    }

    this._reportService.applyFilter();
  }
}
